import type { AnalyticsType } from '@ria-client/segment/types';
import type { CtaType, ImageType } from '@ria-client/supergraph/roundup/types';
import { DesktopProductSection } from './desktop';
import { MobileProductSection } from './mobile';

export interface ProductSectionProps {
  cta?: CtaType;
  ctaAnalytics: AnalyticsType;
  displayName?: string;
  image?: ImageType;
  federallyInsuredAnnotation?: string;
  starRating?: number;
  starRatingTooltip?: string;
  reviewLink?: string;
}

export function ProductSection(props: ProductSectionProps) {
  return (
    <>
      <div className="md:hidden">
        <MobileProductSection {...props} />
      </div>
      <div className="hidden md:block">
        <DesktopProductSection {...props} />
      </div>
    </>
  );
}
